<template>
  <div :class="'category-list scroll-list'+ (grid ? 'grid' : '')">
    <el-row
      v-if="header !== false"
      type="flex"
      justify="space-between"
      align="middle"
      class="list-header">
      <h4 class="heading">{{ header }}</h4>
      <!-- <el-button type='text' @click="$router.push('/categories')">MORE <i class="el-icon-arrow-right el-icon-right"></i></el-button> -->
    </el-row>
    <!-- <el-row type="flex" class="scroll-list">
      <category-card :category="item" v-for="(item, index) in categories" :key="index"></category-card>
    </el-row> -->
    <div
      v-if="!grid"
      class="list-row">
      <div
        v-if="show_nav"
        class="left-nav slider-nav"
        @click="slideRight">
        <!-- <i class="fas fa-chevron-left"></i> -->
        <img
          src="../assets/images/slider_left.png"
          alt="">
      </div>
      <swiper
        ref="mySwiper"
        :options="swiperOption"
        :class="{'show-border': show_nav}">
        <swiper-slide
          v-for="(item, index) in categories"
          :key="index">
          <category-card :category="item"/>
        </swiper-slide>
      </swiper>
      <div
        v-if="show_nav"
        class="right-nav slider-nav"
        @click="slideLeft">
        <!-- <i class="fas fa-chevron-right"></i> -->
        <img
          src="../assets/images/slider_right.png"
          alt="">
      </div>
    </div>
    <div
      v-if="grid"
      class="d-flex flex-wrap grid-wrapper">
      <category-card
        v-for="(item, index) in categories"
        :category="item"
        :grid="true"
        :key="index"/>
    </div>
  </div>
</template>
<script>
import CategoryCard from './CategoryCard';

export default {
  components: {
    'category-card': CategoryCard,
  },
  props: {
    header: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    grid: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      heading: 'Categories',
      show_nav: false,
      swiperOption: {
        lazy: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        slideToClickedSlide: false,
        simulateTouch: true,
        threshold: 20,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  watch: {
    categories(newVal) {
      this.show_nav = newVal && newVal.length > 5;
      setTimeout(() => {
        this.adjustCardsSize();
      }, 0);
    },
  },
  mounted() {
    this.show_nav = this.categories && this.categories.length > 5;
    this.adjustCardsSize();

    window.onresize = () => {
      this.adjustCardsSize();
    };
  },
  methods: {
    slideRight() {
      this.swiper.slidePrev();
    },
    slideLeft() {
      this.swiper.slideNext();
    },
    adjustCardsSize() {
      const cards = document.getElementsByClassName('category-card');
      if (cards.length && this.grid) {
        const width = cards[0].clientWidth;
        const resizeCardsLength = (cards.length > 6) ? (cards.length - 6) : cards.length;
        for (let i = (cards.length - 1); i > resizeCardsLength; i--) {
          const card = cards[i];
          card.style.maxWidth = `${width}px`;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.category-list {
  .swiper-slide { width: 14rem;}

  .list-row {
    .slider-nav {
      top: 62% !important;
    }
  }

  .grid-wrapper {
    margin-left: -8px;
    margin-right: -8px;
    margin-bottom: 48px;
  }
}

.category-list.grid {
  margin: 0;

  .scroll-list {
    .list-row {
      flex-wrap: wrap;
      width: 100%;
      margin-left: inherit;
    }
  }

  .scroll-list > *:first-child {
    margin-left: inherit;
  }
}

@media(max-width: 768px) {
  .category-list {
    .swiper-slide {
      margin-right: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/CategoryList.vue